<form [formGroup]="form" class="flex flex-col">
    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="13"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>FCC Registration Number (FRN)</mat-label>
                <input
                    title="FCC Registration Number (FRN)"
                    matInput
                    formControlName="fccRegistrationNumber"
                    [appRegexInput]="regExPattern.NumericOnly"
                    maxLength="10"
                />
            </mat-form-field>
        </app-application-form-field>
        @if (isNewApplication) {
            <div
                class="w-full xl:col-span-3 2xl:col-span-1 flex items-start gap-2 xl:-ml-16 mb-6 pl-12 xl:pl-0 xl:leading-3"
            >
                <button
                    type="button"
                    name="frn-search"
                    mat-button
                    mat-raised-button
                    color="primary"
                    class="!rounded-lg !px-14 !py-5"
                    [disabled]="isReadOnly()"
                    (click)="openFrnSearchDialog()"
                >
                    FRN Search
                </button>
                <button
                    type="button"
                    name="frn-request-or-view"
                    mat-button
                    mat-raised-button
                    color="primary"
                    class="!rounded-lg !px-14 !py-5"
                    [disabled]="
                        isReadOnly() && !applicationState?.hasFrnRequest
                    "
                    (click)="onFrnRequestOrViewClick()"
                >
                    {{
                        applicationState?.hasFrnRequest
                            ? 'View FRN Request'
                            : 'Request an FRN'
                    }}
                </button>
            </div>
        }
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="14"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Applicant/Licensee Legal Entity Type</mat-label>
                <mat-select formControlName="applicantTypeCode">
                    @for (
                        applicantTypeOption of applicantTypeOptions;
                        track applicantTypeOption.value
                    ) {
                        <mat-option [value]="applicantTypeOption.value">{{
                            applicantTypeOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="15"
            class="w-full xl:col-span-9 2xl:col-span-1"
            [tooltipMessage]="messages.licenseeNameChange"
            [showTooltipIcon]="true"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Is the Licensee Name Being Updated?</mat-label>
                <mat-select formControlName="licenseeNameChange">
                    @for (
                        yesNoOption of yesNoOptions;
                        track yesNoOption.value
                    ) {
                        <mat-option [value]="yesNoOption.value">{{
                            yesNoOption.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap">
        <app-application-form-field fieldNumber="16">
            <div
                class="flex flex-wrap space-y-4 xl:space-y-0 xl:mb-0 xl:grid xl:grid-cols-12 xl:gap-4"
            >
                <div class="w-full xl:col-span-3 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>First Name</mat-label>
                        <input
                            title="First Name"
                            matInput
                            formControlName="licenseeFirstName"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="20"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Middle Initial</mat-label>
                        <input
                            title="Middle Initial"
                            matInput
                            formControlName="licenseeMiddleInitial"
                            [appRegexInput]="
                                regExPattern.AlphabeticalCharacters
                            "
                            maxLength="1"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Last Name</mat-label>
                        <input
                            title="Last Name"
                            matInput
                            formControlName="licenseeLastName"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="20"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Suffix</mat-label>
                        <input
                            title="Suffix"
                            matInput
                            formControlName="licenseeSuffix"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="3"
                        />
                    </mat-form-field>
                </div>
            </div>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="17"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label
                    >Legal Entity Name (If other than individual)</mat-label
                >
                <input
                    title="Legal Entity Name (If other than individual)"
                    matInput
                    formControlName="licenseeEntityName"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="200"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="18"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Attention To</mat-label>
                <input
                    title="Attention To"
                    matInput
                    formControlName="licenseeAttentionTo"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="200"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="19"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>P.O. Box</mat-label>
                <input
                    title="P.O. Box"
                    matInput
                    formControlName="licenseePoBox"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="20"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="20"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Street Address</mat-label>
                <input
                    title="Street Address"
                    matInput
                    formControlName="licenseeStreetAddress"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="60"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap">
        <div
            class="flex flex-wrap space-y-2 xl:space-y-0 xl:mb-0 xl:grid xl:grid-cols-12 xl:gap-4"
        >
            <app-application-form-field
                fieldNumber="21"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>City</mat-label>
                    <input
                        title="City"
                        matInput
                        formControlName="licenseeCity"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="20"
                    />
                </mat-form-field>
            </app-application-form-field>
            <app-application-form-field
                fieldNumber="22"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>State</mat-label>
                    <mat-select
                        formControlName="licenseeStateProvinceInitials"
                        appSelectTypeahead
                    >
                        @for (
                            stateCode of stateCodeOptions;
                            track stateCode.value
                        ) {
                            <mat-option [value]="stateCode.value">{{
                                stateCode.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
            <app-application-form-field
                fieldNumber="23"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Zip Code</mat-label>
                    <input
                        title="Zip Code"
                        matInput
                        formControlName="licenseePostalCode"
                        [imask]="maskOptions.postalCode"
                        [unmask]="true"
                        [pattern]="regExPattern.PostalCode"
                    />
                </mat-form-field>
            </app-application-form-field>
        </div>
    </div>

    <div class="flex flex-wrap w-full">
        <app-application-form-field fieldNumber="24" class="w-full">
            <app-phone-number-input
                label="Phone"
                title="Phone"
                [control]="form.controls.licenseePhoneNumber"
                [withExtension]="false"
            >
            </app-phone-number-input>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap w-full">
        <app-application-form-field fieldNumber="25" class="w-full xl:w-5/12">
            <app-phone-number-input
                label="Fax"
                title="Fax"
                [control]="form.controls.licenseeFaxNumber"
                [withExtension]="false"
            >
            </app-phone-number-input>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="26"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Email Address</mat-label>
                <input
                    title="Email Address"
                    matInput
                    formControlName="licenseeEmailAddress"
                    [pattern]="regExPattern.EmailAddress"
                    maxlength="50"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <h3 class="application-section-header">Real Party In Interest</h3>
    <hr class="mb-4" />

    <div class="items-start w-full grid grid-cols-12 gap-3 xl:gap-20">
        <app-application-form-field
            fieldNumber="28"
            class="2xl:col-span-6"
            [ngClass]="
                form.controls.realPartyEntityName.value
                    ? 'col-span-9'
                    : 'col-span-12 xl:col-span-9'
            "
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>
                    Real Party in Interest of Applicant if Different From Above
                </mat-label>
                <input
                    title="Name of real party in interest of applicant (if different)"
                    matInput
                    formControlName="realPartyEntityName"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="200"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="items-start w-full grid grid-cols-12 gap-3 xl:gap-20">
        <app-application-form-field
            fieldNumber="29"
            class="2xl:col-span-6"
            [ngClass]="
                form.controls.realPartyFccRegistratonNumber.value
                    ? 'col-span-9'
                    : 'col-span-12 xl:col-span-9'
            "
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label
                    >FCC Registration Number (FRN) of Real Party in
                    Interest</mat-label
                >
                <input
                    title="FCC Registration Number (FRN) of Real Party in Interest"
                    matInput
                    formControlName="realPartyFccRegistratonNumber"
                    [appRegexInput]="regExPattern.NumericOnly"
                    maxLength="10"
                />
            </mat-form-field>
        </app-application-form-field>
        @if (
            form.controls.realPartyFccRegistratonNumber.value ||
            form.controls.realPartyEntityName.value
        ) {
            <div class="flex col-span-3 2xl:col-span-2 xl:-ml-16">
                <app-attachment-required-button
                    class="w-full"
                    buttonText="Add Attachment"
                />
            </div>
        }
    </div>

    <div
        class="flex flex-col items-start space-y-1 xl:items-center xl:flex-row xl:space-y-0 xl:space-x-4"
    >
        <h3 class="application-section-header">
            Contact Information (If different from the Applicant)
        </h3>
        <mat-checkbox
            color="primary"
            formControlName="isContactSameAsApplicant"
        >
            <span class="text-base font-medium"
                >Check Here if Same as Applicant</span
            >
        </mat-checkbox>
        @if (!this.isApplicationTemplate() && !this.isCustomerRole) {
            <mat-checkbox
                color="primary"
                formControlName="hasEmailBookedNotification"
            >
                <span class="text-base font-medium"
                    >Email 'Booked In' Notification</span
                >
            </mat-checkbox>
        }
    </div>

    <hr class="mb-4" />

    <div class="flex flex-wrap">
        <app-application-form-field fieldNumber="30">
            <div
                class="flex flex-wrap space-y-4 xl:space-y-0 xl:mb-0 xl:grid xl:grid-cols-12 xl:gap-4"
            >
                <div class="w-full xl:col-span-3 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>First Name</mat-label>
                        <input
                            title="First Name"
                            matInput
                            formControlName="contactFirstName"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="20"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Middle Initial</mat-label>
                        <input
                            title="Middle Initial"
                            matInput
                            formControlName="contactMiddleInitial"
                            [appRegexInput]="
                                regExPattern.AlphabeticalCharacters
                            "
                            maxLength="1"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Last Name</mat-label>
                        <input
                            title="Last Name"
                            matInput
                            formControlName="contactLastName"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="20"
                        />
                    </mat-form-field>
                </div>
                <div class="w-full xl:col-span-3 2xl:col-span-2 xl:mb-0">
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Suffix</mat-label>
                        <input
                            title="Suffix"
                            matInput
                            formControlName="contactSuffix"
                            [appRegexInput]="
                                regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                            "
                            maxLength="3"
                        />
                    </mat-form-field>
                </div>
            </div>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="31"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Company Name</mat-label>
                <input
                    title="Company Name"
                    matInput
                    formControlName="contactEntityName"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="200"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="32"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Attention To</mat-label>
                <input
                    title="Attention To"
                    matInput
                    formControlName="contactAttentionTo"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="35"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="33"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>P.O. Box</mat-label>
                <input
                    title="P.O. Box"
                    matInput
                    formControlName="contactPoBox"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="20"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="34"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Street Address</mat-label>
                <input
                    title="Street Address"
                    matInput
                    formControlName="contactStreetAddress"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                    maxLength="60"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap">
        <div
            class="flex flex-wrap space-y-2 xl:space-y-0 xl:mb-0 xl:grid xl:grid-cols-12 xl:gap-4"
        >
            <app-application-form-field
                fieldNumber="35"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>City</mat-label>
                    <input
                        title="City"
                        matInput
                        formControlName="contactCity"
                        [appRegexInput]="
                            regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                        "
                        maxLength="20"
                    />
                </mat-form-field>
            </app-application-form-field>
            <app-application-form-field
                fieldNumber="36"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>State</mat-label>
                    <mat-select
                        formControlName="contactStateProvinceInitials"
                        appSelectTypeahead
                    >
                        @for (
                            stateCode of stateCodeOptions;
                            track stateCode.value
                        ) {
                            <mat-option [value]="stateCode.value">{{
                                stateCode.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
            <app-application-form-field
                fieldNumber="37"
                class="w-full xl:col-span-3 xl:mb-0"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Zip Code</mat-label>
                    <input
                        title="Zip Code"
                        matInput
                        formControlName="contactPostalCode"
                        [imask]="maskOptions.postalCode"
                        [unmask]="true"
                        [pattern]="regExPattern.PostalCode"
                    />
                </mat-form-field>
            </app-application-form-field>
        </div>
    </div>

    <div class="flex flex-wrap w-full">
        <app-application-form-field fieldNumber="38" class="w-full xl:w-5/12">
            <app-phone-number-input
                label="Phone"
                title="Phone"
                [control]="form.controls.contactPhoneNumber"
                [withExtension]="false"
            >
            </app-phone-number-input>
        </app-application-form-field>
    </div>

    <div class="flex flex-wrap w-full">
        <app-application-form-field fieldNumber="39" class="w-full xl:w-5/12">
            <app-phone-number-input
                label="Fax"
                title="Fax"
                [control]="form.controls.contactFaxNumber"
                [withExtension]="false"
            >
            </app-phone-number-input>
        </app-application-form-field>
    </div>

    <div
        class="flex flex-wrap w-full xl:grid xl:grid-cols-12 xl:gap-20 2xl:grid-cols-2"
    >
        <app-application-form-field
            fieldNumber="40"
            class="w-full xl:col-span-9 2xl:col-span-1"
        >
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Email Address</mat-label>
                <input
                    title="Email Address"
                    matInput
                    formControlName="contactEmailAddress"
                    [pattern]="regExPattern.EmailAddress"
                    maxlength="50"
                />
            </mat-form-field>
        </app-application-form-field>
    </div>
</form>
